<template>
  <div class="box7">
    <pageTitle
      title="该精必精，拒绝低效内卷"
      text="可以拓展但非必须学习的内容，就要少（不）在必修课程里，<br/>我们合理设置了选修课程，狂野架构师全力支持你的深度拓展。"
    />
    <div class="swiper-box">
      <swiper :options="swiperOptionOne" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="block">
            <div class="nav-title">
              <p>{{ item.title }}</p>
            </div>
            <div class="tag-box">
              <div class="tagOne" v-for="i in item.tag" :key="i">{{ i }}</div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    
    <div class="subject-box" @click="show = true">
      <div
        class="content"
        ref="block"
        :class="[cur == 1 || cur == 2 || cur == 3 ? 'specialClass' : '']"
      >
        <div class="open">
          查看全部
          <img src="../../assets/common/open.png" alt />
        </div>
        <div class="stage">{{ list[cur].title }}</div>
        <div class="tag">
          <img
            class="icon1"
            src="../../assets/cPuls/box6/icon1.png"
            alt
          />
          主要内容
        </div>

        <div
          class="subject-block ability"
          v-for="(item1, index1) in list[cur].primaryCoverage"
          :key="index1 + 'a'"
        >
          <div class="block-title" v-if="item1.itemTit">
            {{ item1.itemTit }}
          </div>
          <div class="block-wrap">
            <p v-for="i in item1.itemArr" :key="i" class="block-p">
              <span></span>
              {{ i }}
            </p>
          </div>
        </div>

        <div class="tag">
          <img
            class="icon2"
            src="../../assets/cPuls/box6/icon2.png"
            alt
          />
          核心能力培养
        </div>
        <div class="subject-block">
          <p v-for="j in list[cur].corCompetence" :key="j">{{ j }}</p>
        </div>

        <div class="tag">
          <img src="../../assets/architect/box6/icon3.png" alt />
          具备市场价值
        </div>
        <div class="subject-block">
          <p v-for="k in list[cur].marketValue" :key="k">{{ k }}</p>
        </div>
      </div>
    </div>

    <van-popup v-model="show" position="bottom" round>
      <div
        v-if="show"
        class="block"
        :class="[
          cur == 1 || cur == 2 || cur == 3 ? 'specialClass' : '',
          cur == 2 ? 'specialTwoClass' : '',
        ]"
      >
        <div class="block-tops">
          <div class="title">{{ list[cur].title }}</div>
          <div class="close" @click="show = false"></div>
        </div>
        <div class="tag tag2">主要内容</div>

        <div
          class="target"
          v-for="(item1, index1) in list[cur].primaryCoverage"
          :key="index1 + 'a'"
        >
          <div class="block-title" v-if="item1.itemTit">
            {{ item1.itemTit }}
          </div>
          <div class="block-wrap">
            <p v-for="i in item1.itemArr" :key="i" class="block-p">
              <span></span>
              {{ i }}
            </p>
          </div>
        </div>

        <div class="tag tag2">核心能力培养</div>
        <div class="target">
          <p v-for="j in list[cur].corCompetence" :key="j">{{ j }}</p>
        </div>

        <div class="tag tag2">具备市场价值</div>
        <div
          class="target"
          :class="list[cur].marketValue.length > 1 ? 'target2' : ''"
        >
          <p v-for="k in list[cur].marketValue" :key="k">{{ k }}</p>
        </div>
      </div>
    </van-popup>
    <div class="btn" @click="childMethod">申请免费试听</div>
  </div>
</template>

<script>
import pageTitle from "../../components/common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  data() {
    let that = this;
    return {
      swiperOptionOne: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        centeredSlides: true,
        // paginationClickable: true,
        spaceBetween: 10,
        // effect: "left",
        on: {
          slideChangeTransitionStart() {
            that.cur = this.realIndex;
          },
          click() {
            if (
              this.clickedIndex == 0 ||
              this.clickedIndex == 4 ||
              this.clickedIndex == 8
            ) {
              that.cur = 0;
            }
            if (
              this.clickedIndex == 1 ||
              this.clickedIndex == 5 ||
              this.clickedIndex == 9
            ) {
              that.cur = 1;
            }
            if (
              this.clickedIndex == 2 ||
              this.clickedIndex == 6 ||
              this.clickedIndex == 10
            ) {
              that.cur = 2;
            }
            if (
              this.clickedIndex == 3 ||
              this.clickedIndex == 7 ||
              this.clickedIndex == 11
            ) {
              that.cur = 3;
            }
            if (this.clickedIndex == 0) {
              that.swiper.slidePrev();
            } else if (this.clickedIndex == 11) {
              that.swiper.slideNext();
            } else {
              that.swiper.slideTo(this.clickedIndex, 400, false);
            }
          },
        },
      },
      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box8",
        },
        on: {
          slideChangeTransitionStart: function () {
            that.cur = this.realIndex;
            document.getElementsByClassName("scorll-box7")[0].scrollLeft =
              this.realIndex * that.$refs.nav[0].offsetWidth;
          },
          click(e) {
            if (
              e.target.className == "open" ||
              (that.$refs.block &&
                e.target.className !=
                  "swiperwrap swiper-slide swiper-slide-active")
            ) {
              that.show = true;
            }
          },
        },
      },
      cur: 0,
      show: false,
      list: [
        {
          title: "数据结构与算法",
          tag: ["内功心法", "每日一题"],
          primaryCoverage: [
            {
              itemArr: [
                "算法开篇",
                "数组与链表",
                "栈和队列",
                "Hash和初识递归",
                "树和堆",
                "图、递归、分治、回溯",
                "搜索、贪心、二分查找",
              ],
            },
            {
              itemArr: [
                "动态规划、字典树和并查集",
                "高级搜索、avl树和红黑树",
                "红黑树高级和位运算",
                "布隆过滤器、LRU",
                "排序、字符串算法",
                "字符串加强、数据结构与算法工程应用",
                "算法面试技巧",
              ],
            },
          ],
          corCompetence: [
            "1. 掌握各类基础的数据结构",
            "2. 掌握各类基本的算法理论",
            "3. 大厂常见高频面试题",
          ],
          marketValue: [
            "1. 突破大厂面试中的算法关",
            "2. 为成长为高阶架构师打下基础",
            "3. 手撕大厂算法面试官",
          ],
        },
     
        {
          title: "解决方案",
          tag: ["行业积累", "技术沉淀"],
          primaryCoverage: [
            {
              itemTit: "行业项目经验",
              itemArr: [
                "《餐掌柜》",
                "《黑马头条》",
                "《闪聚支付》",
                "《Drools规则引擎》",
                "《好客租房》",
              ],
            },
            {
              itemTit: "企业级通用解决方案",
              itemArr: [
                "电商终极搜索ElasticStack",
                "多维系统下单点登录的深入讲解",
                "多服务之间分布式事务的一站解决",
                "每天千万级订单的生成背后痛点及技术实破	",
                "业务幂等性技术架构体系",
                "每秒100W请求的秒杀架构体系",
                "红包雨的架构设计及源码实现",
                "集中化日志管理平台的应用",
                "世界级难题-12306如何深度优化	",
                "大屏实时计算技术深度部析	",
                "电商亿级数据如何设计数据库	",
                "分库分表实战的深入剖析	",
                "数据中台下配置中心技术实现	",
                "公有云服务与场景方案实战	",
                "系统建模规范与实战",
              ],
            },
          ],
          corCompetence: [
            "1. 项目实战，将架构技术体系融入业务中去",
            "2. 积累通用的企业级解决方案",
          ],
          marketValue: [
            "通过快速充电阶段的技术积累，你已经不知不觉中具备了一个架构师的扎实基本功，将技术与项目融合，并具备企业中通用场景解决方案的储备，你将胜任一个架构师的角色。",
          ],
        },
        {
          title: "技术视野",
          tag: ["人工智能", "数据挖掘"],
          primaryCoverage: [
            {
              itemTit: "人工智能",
              itemArr: [
                "概述与环境",
                "四大学习库",
                "K近邻算法",
                "线性&逻辑回归",
                "决策树",
                "集成学习",
                "聚类算法",
                "朴素贝叶斯",
                "SVM/EM/HMM算法",
                "集成学习进阶",
              ],
            },
            {
              itemTit: "数据挖掘",
              itemArr: [
                "机器学习基础",
                "SparkML&SparkMLlib",
                "特征工程实战",
                "分类算法实战",
                "聚类算法实战",
                "回归算法实战",
                "推荐算法实战",
                "高阶主题",
              ],
            },
          ],
          corCompetence: [
            "1. 掌握Python数据科学库",
            "2. 掌握Python机器学习",
            "3. 使⽤SparkML或SparkMLlib完成机器学习",
            "4. 数据挖掘等常⻅分类、回归、聚类及推荐任务",
          ],
          marketValue: [
            "1. 掌握科学计算库及数据处理基本⽅法",
            "2. 掌握数据挖掘基本算法，可进⾏机器学习模型的搭建和优化",
            "3. 在⼤数据存储和计算基础之上，掌握⼤数据挖掘的内容，能够解决企业级⼤数据场景⼈⼯智能常⻅问题，助⼒成为数据架构师及数据科学家",
          ],
        },
           {
          title: "就业突击",
          tag: ["面试指导", "技术八股"],
          primaryCoverage: [
            {
              itemTit: "技术八股",
              itemArr: [
                "架构设计",
                "多线程",
                "JVM",
                "协议",
                "分布式",
                "消息",
                "数据库",
                "NoSQL",
                "算法",
                "JDK",
                "项目管理",
                "微服务",
                "源码",
              ],
            },
            {
              itemTit: "就业指导",
              itemArr: [
                "就业课程&配套资料",
                "就业形势分析",
                "1V1制定就业计划",
                "简历指导&投递技巧",
                "模拟面试",
                "面试跟踪&复盘",
                "Offer选择&入职追踪",
              ],
            },
          ],

          corCompetence: [
            "1. 快速回顾与整理面试需要的技术栈",
            "2. 掌握经典大厂面试题的回答思路",
            "3. 对行业加强认知和理解",
            "4. 加强对工作岗位及流程的理解",
            "5. 增强就业信心",
            "6. 确定职业目标制定就业计划",
            "7. 掌握简历制作和投递的要领",
            "8. 了解企业招聘流程",
            "9. 提升面试沟通表达技巧",
          ],
          marketValue: [
            "1. 了解就业计划的目的和意义，确定好就业规划和目标",
            "2. 快速了解就业市场，找准目标岗位，深入理解岗位招聘信息要求",
            "3. 能独立制作简历，分析不同企业的招聘流程",
            "4. 独立应对各种面试，拿到满意Offer",
            "5. 调整好心态应对入职后的各种问题",
          ],
        },
      ],
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    cSwiper() {
      return this.$refs.contentSwiper.swiper;
    },
  },
  methods: {
    changeCur(index) {
      this.swiper.slideTo(index, 500, false);
      this.cur = index;
      document.getElementsByClassName("scorll-box7")[0].scrollLeft =
        this.cur * this.$refs.nav[0].offsetWidth;
    },
    childMethod() {
      this.$parent.itcastClick();
    }
  },
};
</script>

<style lang="less" scoped>
.box7 {
  padding: 80px 0 88px;
  width: 100%;
  background: #ffffff;
  .btn{
    width: 400px;
    height: 78px;
    font-size: 34px;
    color: #fff;
    text-align: center;
    line-height: 78px;
    border-radius: 14px;
    background: #ff5627;
    margin: 30px auto 0;
  }
  .swiper-box {
    position: relative;
    margin-top: 48px;
    /deep/ .swiper-slide {
      width: 404px;

      .block {
        transform: scale(0.85);
        transition: 0.7s all;
      }
    }
    .block {
      width: 352px;
      background: #f6faff;
      padding: 32px 0;
      width: 100%;
      background-color: #f6faff;
        text-align: center;

   
      border-radius: 20px;

      text-align: center;
      opacity: 0.84;
      border-radius: 20px;
      box-sizing: border-box;

      .nav-title {
        p {
          font-family: PingFangSC-Semibold;
          font-size: 28px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 1px;
          color: #4e5969;
        }
      }
      .tag-box {
        display: flex;
        justify-content: center;
        margin-top: 10px;
        .tagOne {
          margin: 0px 10px;
          padding: 0px 16px;
          border-radius: 6px;
          line-height: 36px;
          text-align: center;
          height: 36px;
          border: 1px solid #7b8593;
          font-family: PingFang SC;
          font-size: 24px;
          color: #4e5969;
        }
      }
    }
    .swiper-slide-active {
      .block {
        transform: scale(1);
        transition: 0.7s all;
        opacity: 1;
        background-image: linear-gradient(8deg, #006aff 0%, #33b0ff 100%);
        .nav-title {
          p {
            color: #ffffff;
            text-shadow: 0px 6px 8px 0px rgba(5, 109, 255, 0.77);
          }
        }
        .tag-box {
          .tagOne {
            color: #ffffff;
            border: solid 1px #ffffff;
          }
        }
      }
    }
  }
  .van-popup {
    padding-bottom: 24px;
    max-height: calc(100% - 80px);
    box-sizing: border-box;
    .block-title {
      margin-bottom: 8px;
      color: #1d2129;
      font-family: PingFangSC-Semibold;
      position: relative;
      margin-left: 30px;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }

    .specialClass {
      .block-wrap {
        margin-left: 30px !important;
      }
    }
    /*.specialTwoClass {
      .target:nth-child(4) {
        .block-wrap {
          .block-p {
            &::after {
              display: none;
            }
          }
        }
      }
    }*/
  }

  .title {
    margin-bottom: 48px;
    font-family: PingFangSC-Semibold;
    font-size: 40px;
    font-weight: bold;
    font-stretch: normal;

    text-align: center;
    letter-spacing: 0px;
    color: #24375c;

    p {
      margin-top: 20px;
      font-family: PingFang SC;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 40px;
      letter-spacing: 0px;
      color: #24375c;
    }
  }
  .subject-box {
    position: relative;
    margin-top: 48px;
    // padding-left: 32px;
    // padding-bottom: 22px;

    width: 100%;
    box-sizing: border-box;
    overflow: hidden;

    .scorll-box7 {
      overflow-x: auto;
      transition: 0.3 all;
      display: flex;
      .seat {
        width: 32px;
        flex-shrink: 0;
        position: static;
      }
      &::-webkit-scrollbar {
        display: none;
        width: 0 !important;
        height: 0 !important;
        color: transparent;
      }
    }

    .nav-box {
      display: flex;
      padding-left: 32px;
      // padding-right: 20px;
      padding-bottom: 40px;
      white-space: nowrap;
      // width: 100%;

      .nav {
        margin-right: 32px;
        padding: 32px 0;
        min-width: 404px;

        background-color: #f6faff;
        text-align: center;
        border-radius: 20px;
        box-sizing: border-box;

        .nav-title {
          font-family: PingFangSC-Semibold;
          font-size: 28px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 36px;
          letter-spacing: 1px;
          color: #4e5969;
        }
        .tag-box {
          display: flex;
          justify-content: center;
          margin-top: 10px;
          .tag {
            margin: 0px 10px;
            padding: 0px 16px;
            border-radius: 6px;
            line-height: 36px;
            text-align: center;
            height: 36px;
            border: 1px solid #7b8593;
            font-family: PingFang SC;
            font-size: 24px;
            color: #4e5969;
          }
        }
      }

      .cur-nav {
        position: relative;
        background-image: linear-gradient(8deg, #006aff 0%, #33b0ff 100%);
        .nav-title {
          color: #ffffff;

          text-shadow: 0px 6px 8px 0px rgba(5, 109, 255, 0.77);
        }
        .tag-box {
          .tag {
            color: #ffffff;
            border: solid 1px #ffffff;
          }
        }
      }
    }
  }

  .content {
    position: relative;
    margin: 0 auto;
    margin-bottom: 38px;
    padding: 40px;
    width: 690px;
    height: 700px;
    background: url("../../assets/architect/box6/box.png")
      no-repeat;
    background-size: cover;
    box-shadow: 0px 6px 24px 0px #dbefff;
    border-radius: 20px;
    box-sizing: border-box;
    overflow: hidden;

    .open {
      position: absolute;
      left: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 30px;
      width: 100%;
      height: 140px;
      // background: #fff;
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 40%,
        #fff 100%
      );
      border-radius: 0px 0px 20px 20px;
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #86909c;
      line-height: 36px;
      box-sizing: border-box;
      z-index: 40;

      img {
        margin-left: 8px;
        width: 32px;
        height: 32px;
      }
    }
  }

  .stage {
    margin-bottom: 40px;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 1px;
    color: #006aff;
  }
  .tag {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    height: 44px;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #1d2129;
    line-height: 44px;

    img {
      margin-right: 12px;
      width: 32px;
      height: 32px;
      background-size: contain;
    }
  }

  .subject-block {
    margin-bottom: 48px;
    .block-title {
      color: rgb(51, 51, 51);

      font-size: 26px;
      margin-bottom: 8px;
      font-family: PingFangSC-Medium;
      margin-left: 45px;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
    p {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-left: 45px;
      i {
        display: none;
        width: 4px;
        height: 4px;
        background: #87d4bd;
        border-radius: 2px;
        margin-right: 16px;
      }
    }
  }
  .ability {
    p {
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 4px;
        height: 4px;
        background: #86909c;
        position: absolute;
        left: -22px;
        top: 18px;
        border-radius: 50%;
      }
    }
  }
  .pop-title {
    position: sticky;
    top: 0px;
    display: flex;
    justify-content: space-between;
    padding: 40px 0px;
    width: 610px;
    background: #fff;
    box-sizing: border-box;
    z-index: 50;
    .close {
      width: 32px;
      height: 32px;
      background: url("../../assets/common/close.png") no-repeat;
      background-size: cover;
    }
  }

  .swiper-pagination-box8 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: 0px;
    transform: translate(-50%, 0px);
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    // background: rgba(46, 165, 252, 0.16);
    // border-radius: 3px;
  }

  /deep/ .swiper-pagination-bullet {
    min-width: 20px;
    height: 6px;
    background-color: #b6ddff;
    border-radius: 3px;
    opacity: 1;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background-color: #57a3f5;
    border-radius: 3px;
  }
  .block {
    position: relative;
    margin: 0 auto;
    padding-top: 0px;
    padding: 0 48px;
    // padding-top: 128px;

    // height: 640px;
    background: #ffffff;
    // box-shadow: 4px 8px 20px 0px rgba(0, 0, 0, 0.04);
    border-radius: 20px;
    // border: 1px solid #ffffff;

    box-sizing: border-box;

    .block-tops {
      position: sticky;
      top: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      width: 100%;
      height: 132px;
      padding-top: 16px;
      background: #ffffff;
      box-sizing: border-box;
      z-index: 10;
      .title {
        font-size: 36px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #1d2129;
        margin-bottom: 0;
      }
      .close {
        width: 32px;
        height: 32px;
        background: url("../../assets/common/close.png")
          no-repeat;
        background-size: cover;
      }
    }
    .exp {
      font-size: 28px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 40px;
    }
    .intro {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;
    }

    .demo {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 40px;
      p {
        display: flex;
        align-items: center;

        span {
          margin-right: 8px;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #00a8ff;
        }
      }
    }

    .tag {
      padding: 0 24px;
      width: max-content;
      height: 56px;
      background: #e8f1ff;
      border-radius: 0px 32px 32px 24px;
      text-align: center;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2674ff;
      line-height: 56px;
    }
    .tag2 {
      margin-bottom: 24px;
    }
    .target {
      font-size: 26px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4e5969;
      line-height: 44px;
      margin-bottom: 40px;

      .block-p {
        position: relative;
        margin-left: 25px;
        &::before {
          content: "";
          display: block;
          width: 4px;
          height: 4px;
          background: #86909c;
          position: absolute;
          left: -22px;
          top: 18px;
          border-radius: 50%;
        }
      }
    }
  }
  .specialClass {
    .block-p {
      display: inline-block !important;
      position: relative !important;
      margin-left: 0 !important;
      &::before {
        display: none !important;
      }
      &::after {
        content: "、";
        display: inline-block;
      }
      .block-p:last-child {
        &::after {
          display: none;
        }
      }
    }
    .block-wrap {
      margin-left: 42px;
      .block-p:last-child {
        &::after {
          display: none;
        }
      }
    }
  }
  .swiperwrap:nth-child(3) {
    .subject-block:nth-child(5) {
      .block-p {
        &::after {
          display: none;
        }
      }
    }
  }
  .target2 {
    p {
      padding-left: 33px;
      text-indent: -33px;
    }
  }
}
</style>
